import { type Theme, useMediaQuery } from "@mui/material";
import { Platform } from "@src/mobile/utils/platform";

/**
 * Returns true when viewport is mobile size (< tablet breakpoint)
 * Use this hook to render mobile-specific layouts
 */
export function useIsMobile() {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
}

/**
 * Returns true when the user should see the mobile experience — narrow
 * viewport OR running inside the Capacitor native shell. Use this for
 * routing decisions (e.g. desktop↔mobile redirects) so both branches
 * share one source of truth and can't ping-pong.
 */
export function useIsMobileDevice() {
  return useIsMobile() || Platform.isMobile;
}

/**
 * Returns true when viewport is tablet size (>= tablet breakpoint and < desktop breakpoint)
 * Returns true only for tablet range (tablet - desktop - 1px)
 */
export function useIsTablet() {
  return useMediaQuery((theme: Theme) => theme.breakpoints.between("md", "lg"));
}

/**
 * Returns true when viewport is desktop size (>= desktop breakpoint)
 * Use this hook for desktop-specific features
 */
export function useIsDesktop() {
  return useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));
}
